<template>
  <svg ref="barcode" class="barcode"></svg>
</template>

<script>
import JsBarcode from "jsbarcode";

export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.$nextTick(() => {
          if (this.$refs.barcode) {
            JsBarcode(this.$refs.barcode, newVal, {
              format: "CODE128",
              displayValue: false,
              width: 4,
              height: 80,
              lineColor: "#000"
            });
          }
        });
        // JsBarcode(this.$refs.barcode, newVal, {
        //   format: "CODE128",
        //   displayValue: true,
        //   width: 2,
        //   height: 80,
        //   lineColor: "#000"
        // });
      }
    }
  }
};
</script>
<style>
svg.barcode {
  max-width: 100%;
}
</style>
